"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var libphonenumber_js_1 = require("libphonenumber-js");

var TextInput_1 = __importDefault(require("../TextInput"));

var Select_1 = __importDefault(require("../selects/Select"));

var countryCodes_1 = __importDefault(require("./countryCodes"));

var styled_1 = require("./styled");

var opts = Object.keys(countryCodes_1.default).map(function (key) {
  return {
    // @ts-ignore
    value: countryCodes_1.default[key].iso2,
    // @ts-ignore
    label: countryCodes_1.default[key].name,
    // @ts-ignore
    secondaryLabel: "+" + countryCodes_1.default[key].code
  };
});

var PhoneInput =
/** @class */
function (_super) {
  __extends(PhoneInput, _super);

  function PhoneInput(props) {
    var _this = _super.call(this, props) || this;

    _this.getValues = function () {
      var _a;

      var id = _this.props.id;
      var _b = _this.state,
          code = _b.code,
          number = _b.number;
      var phoneNumber = "+" + code + number;

      if (id && phoneNumber) {
        return _a = {}, _a[id] = phoneNumber, _a;
      }

      return {};
    };

    _this.onChange = function () {
      if (_this.props.onChange) {
        _this.props.onChange(_this.state);
      }
    };

    _this.onCodeChange = function (option) {
      // @ts-ignore
      var code = countryCodes_1.default[option.value].code;
      var number = _this.state.number;
      var phonenumber = libphonenumber_js_1.parsePhoneNumberFromString("" + code + number);

      _this.setState({
        code: code,
        displayLabel: "+" + code,
        // country: key,
        isDirty: phonenumber !== undefined ? !phonenumber.isValid() : false
      }, function () {
        _this.onChange();
      });
    };

    _this.onNumberChange = function (data) {
      var number = data.value;
      var code = _this.state.code;
      var phonenumber = libphonenumber_js_1.parsePhoneNumberFromString("" + code + number);

      _this.setState({
        number: data.value,
        isDirty: phonenumber !== undefined ? !phonenumber.isValid() : false
      }, function () {
        _this.onChange();
      });
    };

    var phonenumber = props.defaultValue !== undefined ? libphonenumber_js_1.parsePhoneNumberFromString(props.defaultValue) : undefined;

    if (phonenumber !== undefined) {
      _this.state = {
        isDirty: false,
        country: phonenumber.country,
        displayLabel: "+" + phonenumber.countryCallingCode,
        code: "" + phonenumber.countryCallingCode,
        number: "" + phonenumber.nationalNumber
      };
    } else {
      _this.state = {
        isDirty: false,
        displayLabel: '',
        code: '',
        number: ''
      };
    }

    return _this;
  }

  PhoneInput.prototype.render = function () {
    return react_1.default.createElement(styled_1.PhoneWrapper, {
      cols: '120px 1fr'
    }, react_1.default.createElement(Select_1.default, {
      options: opts,
      onChange: this.onCodeChange,
      value: this.state.country,
      displayLabel: this.state.displayLabel,
      allowSearch: true
    }), react_1.default.createElement(TextInput_1.default, {
      tight: true,
      onChange: this.onNumberChange,
      value: this.state.number,
      autoComplete: "tel",
      isDirty: this.state.isDirty
    }));
  };

  return PhoneInput;
}(react_1.PureComponent);

exports.PhoneInput = PhoneInput;
exports.default = PhoneInput;